import React, {useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {AppDispatch} from '~/redux/root-store';
import {useNotification} from '~/hooks';
import {RootState} from '~/redux/root-reducer';
import NotFoundPage from '~/pages/not-found';
import {BIRTH_CONTROL_REQUEST_KEYS} from '~/constants/medical-questionnaires';
import Questionnaire1Screen from '~/pages/homes/birth-control-request/Questionnaire1Screen';
import Questionnaire2Screen from '~/pages/homes/birth-control-request/Questionnaire2Screen';
import Questionnaire3Screen from '~/pages/homes/birth-control-request/Questionnaire3Screen';
import Questionnaire4Screen from '~/pages/homes/birth-control-request/Questionnaire4Screen';
import Questionnaire4bScreen from '~/pages/homes/birth-control-request/Questionnaire4bScreen';
import Questionnaire5Screen from '~/pages/homes/birth-control-request/Questionnaire5Screen';
import Questionnaire6Screen from '~/pages/homes/birth-control-request/Questionnaire6Screen';
import Questionnaire7Screen from '~/pages/homes/birth-control-request/Questionnaire7Screen';
import Questionnaire8Screen from '~/pages/homes/birth-control-request/Questionnaire8Screen';
import Questionnaire9Screen from '~/pages/homes/birth-control-request/Questionnaire9Screen';
import Questionnaire10Screen from '~/pages/homes/birth-control-request/Questionnaire10Screen';
import Questionnaire11Screen from '~/pages/homes/birth-control-request/Questionnaire11Screen';
import Questionnaire12Screen from '~/pages/homes/birth-control-request/Questionnaire12Screen';
import Questionnaire13Screen from '~/pages/homes/birth-control-request/Questionnaire13Screen';
import Questionnaire4PurchasedScreen from '~/pages/homes/birth-control-request/Questionnaire4PurchasedScreen';
import {trackPageViewGA} from '~/services/google-analytics';

const BirthControlRequest = () => {
  const dispatch: AppDispatch = useDispatch();
  const {addMessage} = useNotification(dispatch);
  const activeQuestion = useSelector((state: RootState) => state.questionnaires.activeQuestion);
  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);

  const questionnaires = medicalQuestionnaire?.questionnaires;

  if (!questionnaires?.length) return null;

  const renderQuestion = () => {
    const keys = activeQuestion.keys;
    const key = keys[keys.length - 1];
    switch (key) {
      case BIRTH_CONTROL_REQUEST_KEYS.START:
        trackPageViewGA('/bc-request/start', 'MDQ-BC Request - Start');
        return <Questionnaire1Screen />;
      case BIRTH_CONTROL_REQUEST_KEYS.PROFILE:
        trackPageViewGA('/bc-request/profile', 'MDQ-BC Request - Profile');
        return <Questionnaire2Screen />;
      case BIRTH_CONTROL_REQUEST_KEYS.INVALID:
        trackPageViewGA('/bc-request/invalid', 'MDQ-BC Request - Invalid');
        return <Questionnaire3Screen />;
      case BIRTH_CONTROL_REQUEST_KEYS.BRAND_USED:
        trackPageViewGA('/bc-request/brand-used', 'MDQ-BC Request - Brand Used');
        return <Questionnaire4Screen />;
      case BIRTH_CONTROL_REQUEST_KEYS.BRAND_USED_B:
        trackPageViewGA('/bc-request/brand-used-b', 'MDQ-BC Request - Brand Used B');
        return <Questionnaire4bScreen />;
      case BIRTH_CONTROL_REQUEST_KEYS.LAST_BC_PURCHASE:
        trackPageViewGA('/bc-request/last-bc-purchase', 'MDQ-BC Request - Last BC Purchase');
        return <Questionnaire4PurchasedScreen />;
      case BIRTH_CONTROL_REQUEST_KEYS.STATEMENT_BEST_APPLIES:
        trackPageViewGA('/bc-request/statement-best-applies', 'MDQ-BC Request - Statement Best Applies');
        return <Questionnaire5Screen />;
      case BIRTH_CONTROL_REQUEST_KEYS.MEDICAL_HISTORY:
        trackPageViewGA('/bc-request/medical-history', 'MDQ-BC Request - Medical History');
        return <Questionnaire6Screen />;
      case BIRTH_CONTROL_REQUEST_KEYS.HAD_BLOOD_PRESSURE_MEASURED_LAST_6_MONTH:
        trackPageViewGA(
          '/bc-request/had-blood-pressure-measured-last-6-month',
          'MDQ-BC Request - Had Blood Pressure Measured Last 6 Month',
        );
        return <Questionnaire7Screen />;
      case BIRTH_CONTROL_REQUEST_KEYS.DO_SMOKE:
        trackPageViewGA('/bc-request/do-smoke', 'MDQ-BC Request - Do Smoke');
        return <Questionnaire8Screen />;
      case BIRTH_CONTROL_REQUEST_KEYS.HAS_SMOKED:
        trackPageViewGA('/bc-request/has-smoked', 'MDQ-BC Request - Has Smoked');
        return <Questionnaire9Screen />;
      case BIRTH_CONTROL_REQUEST_KEYS.MEDICATION_BEING_TREATED:
        trackPageViewGA('/bc-request/medication-being-treated', 'MDQ-BC Request - Medication Being Treated');
        return <Questionnaire10Screen />;
      case BIRTH_CONTROL_REQUEST_KEYS.OTHER_MEDICAL_HISTORY:
        trackPageViewGA('/bc-request/other-medical-history', 'MDQ-BC Request - Other Medical History');
        return <Questionnaire11Screen />;
      case BIRTH_CONTROL_REQUEST_KEYS.CHOOSE_MEDICATION:
        trackPageViewGA('/bc-request/choose-medication', 'MDQ-BC Request - Choose Medication');
        return <Questionnaire12Screen />;
      case BIRTH_CONTROL_REQUEST_KEYS.CHOOSE_PRODUCT_PACKAGE:
        trackPageViewGA('/bc-request/choose-product-package', 'MDQ-BC Request - Choose Product Package');
        return <Questionnaire13Screen />;
      default:
        // eslint-disable-next-line no-console
        console.warn('Not implement yet!');
        return <NotFoundPage />;
    }
  };

  return renderQuestion();
};

export default BirthControlRequest;
